import { useNextRouter } from '@/data/Content/_NextRouter';
import {
	DATA_KEY_CATENTRY,
	DATA_KEY_SERIES,
	variantsByCatentryIdFetcher,
	variantsBySeriesFetcher,
} from '@/data/Content/_Series';
import { useSettings } from '@/data/Settings';
import { useUser } from '@/data/User';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import {
	CATALOG_ID_B2B_SC,
	CATALOG_ID_B2B_SC_PUBLIC,
} from 'integration/data/fiwe/catalog/CatalogConstants';
import useSWR from 'swr';

export const useSeriesByCatentryId = (catentryId: string) => {
	const router = useNextRouter();
	const { settings } = useSettings();
	const { storeId } = getClientSideCommon(settings, router);
	const { user } = useUser();
	const catalogId = user?.isLoggedIn ? CATALOG_ID_B2B_SC : CATALOG_ID_B2B_SC_PUBLIC;

	const {
		data: variants,
		mutate,
		isLoading,
	} = useSWR(
		storeId ? [{ storeId }, DATA_KEY_CATENTRY, catalogId, catentryId] : null,
		async ([{ storeId }]) => variantsByCatentryIdFetcher(true)(storeId, catalogId, catentryId),
		{ revalidateOnFocus: false }
	);

	return {
		...variants,
		mutateVariants: mutate,
		isLoading,
	};
};

export const useSeriesBySeries = (series: string | null) => {
	const router = useNextRouter();
	const { settings } = useSettings();
	const { storeId } = getClientSideCommon(settings, router);
	const { user } = useUser();
	const catalogId = user?.isLoggedIn ? CATALOG_ID_B2B_SC : CATALOG_ID_B2B_SC_PUBLIC;

	const {
		data: variants,
		mutate,
		isLoading,
	} = useSWR(
		storeId ? [{ storeId }, DATA_KEY_SERIES, catalogId, series] : null,
		async ([{ storeId }]) => variantsBySeriesFetcher(true)(storeId, catalogId, series),
		{ revalidateOnFocus: false }
	);

	return {
		...variants,
		mutateSeriesVariants: mutate,
		isLoading,
	};
};
